import { CompositePackagingModel } from './composite-packaging.model';
import { InnerPackagingModel } from './inner-packaging.model';
import { OverPackagingModel } from './over-packaging.model';
import { Packages } from './packages.interface';
import { SinglePackagingModel } from './single-packaging.model';

export class ShippingPaper implements Packages {
  Id?: number = undefined;
  Name = '';
  Description?: string;
  Shipper = '';
  Consignee = '';
  Reference?: string;
  AdditionalHandlingInformation?: string;
  PortOfDeparture?: string;
  PortOfDestination?: string;
  AirWayBill?: string;
  EmergencyTelephoneNumber?: string;
  OriginalReceivedElectronically?: string;
  SignatoryName?: string;
  SignatoryTitle?: string;
  SignatoryPlace?: string;
  ShippingDate?: string;
  IsShippingDateUnknown?: boolean;
  ContainerVehicleIdentification?: string;
  GrossMass?: string;
  SealNumbers?: string;
  PackingCertificateSignatoryName?: string;
  SignatoryRole?: string;
  SignatoryCompanyName?: string;
  PackingPlace?: string;
  PackingDate?: string;
  IsMultimodalTransportation?: boolean;
  IsPackingDateUnknown?: boolean;
  HideDocumentLoadFunctionality = false;
  SinglePackagingItems: SinglePackagingModel[] = [];
  CompositePackagingItems: CompositePackagingModel[] = [];
  InnerPackagingItems: InnerPackagingModel[] = [];
  OverpackPackagingItems: OverPackagingModel[] = [];
}
